export default __webpack_public_path__ + "static/1084-21f24b10533ac967ef476214782b1b9f.gif";